import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CodeReviewCommentModel } from 'src/app/Models/code-review-comment-model';
import { CodeReviewerModel } from 'src/app/Models/code-reviewer-model';
import { TechnicalDetailsModel } from 'src/app/Models/technical-details-model';
import { CodeReviewService } from 'src/app/Services/code-review.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { SharedService } from 'src/app/Services/shared.service';
import { UserService } from 'src/app/Services/user.service';

@Component({
  selector: 'ze-code-review-conversation',
  templateUrl: './code-review-conversation.component.html',
  styleUrls: ['./code-review-conversation.component.scss']
})
export class CodeReviewConversationComponent implements OnInit {
  reviewId!: string;
  projectId: string;
  codeReviewComments: CodeReviewCommentModel[] = []
  commentsModification: any[] = [];
  reviewerOptions: CodeReviewerModel[];
  assignedReviewers: CodeReviewerModel[];
  codeReviewCreatedBy: string;
  codeReviewersForm: FormGroup;
  normalCommentForm: FormGroup;
  editReviewers: boolean = false;
  conversationApiLoaded: boolean = false;
  isUpdatingDeleted: boolean = false;
  isReviewerLoading: boolean = false;
  isOtherCodeReviewOpenedForArtifactId: boolean = false;
  currentUser: string = null;
  codeReviewState: string = "";
  technicalDetailsModelList: TechnicalDetailsModel[] = [];

  constructor(private route: ActivatedRoute,
    private router: Router,
    private _codeReviewService: CodeReviewService,
    private userService: UserService,
    private _sharedService: SharedService,
    private notifyService: NotifyService,
    private formBuilder: FormBuilder,) { }

  ngOnInit() {
    this._sharedService.loaderHide.emit(true);
    this.currentUser = this.parseJwt(JSON.parse(localStorage.getItem("currentUser")).token).sub;
    this.route.params.subscribe(params => {
      this.reviewId = params['reviewId'];
      this.projectId = localStorage.getItem("projectId");
      this.codeReviewersForm = this.buildForm();
      this.normalCommentForm = this.buildNormalCommentForm();
      this._codeReviewService.getCodeReviewConversationAndAssignedReviewersById(this.reviewId).subscribe(data => {
        if(data["operationStatus"] != "ERROR") {
          this.conversationApiLoaded = true;
          this.codeReviewComments = data["data"][0];
          this.assignedReviewers = data["data"][1];
          this.codeReviewCreatedBy = data["data"][2];
          this.codeReviewState = data["data"][3];
          this.technicalDetailsModelList = data["data"][4];
          this.isOtherCodeReviewOpenedForArtifactId = data["data"][5];
          this.initializecommentsModification();
        }
        this._sharedService.loaderHide.emit(false);
      }, error => {
        this._sharedService.loaderHide.emit(false);
      });
    });
  }

  buildNormalCommentForm(): FormGroup {    
    const commentForm: FormGroup = this.formBuilder.group({
      comment: new FormControl("")
    })
    return commentForm;
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

  isCurrentUserCodeReview() {
    return this.currentUser != null && this.codeReviewCreatedBy != null && this.codeReviewCreatedBy != undefined && this.currentUser == this.codeReviewCreatedBy;
  }

  isReRequestDisabled() {
    return !(this.currentUser != null && this.codeReviewState == "OPENED" && this.codeReviewCreatedBy != null && this.codeReviewCreatedBy != undefined && (this.currentUser == this.codeReviewCreatedBy || (this.assignedReviewers && this.assignedReviewers.some(assigned => assigned.user_id === this.currentUser))));
  }

  addNormalComment() {
    if(this.normalCommentForm.controls.comment.value != '') {
      this._sharedService.loaderHide.emit(true);
      this._codeReviewService.addNormalCommentByCodeReviewId(this.normalCommentForm.controls.comment.value, this.reviewId).subscribe(data => {      
        if(data["operationStatus"] == "ERROR") {
          this.notifyService.notify('error', 'Failed', 'Error in Adding Comment');
        } else {
          this.normalCommentForm.controls.comment.setValue("");
          this.commentsModification.push({
            replyText: '',
            isEditing: false,
            editText: '',
            isReplying: false
          });
          this.codeReviewComments.push(data["data"]);
        }
        this._sharedService.loaderHide.emit(false);
      }, error => {
        this.notifyService.notify('error', 'Failed', 'Error in Adding Comment');
        this._sharedService.loaderHide.emit(false);
      });
    }
  }

  buildForm(): FormGroup {    
    const reviewForm: FormGroup = this.formBuilder.group({
      reviewers: new FormControl([])
    })
    return reviewForm;
  }

  openEditReviwers() {
    this._sharedService.loaderHide.emit(true);
    this.editReviewers = true;
    this.getReviewers();    
  }

  getReviewers() {
    this.userService.getReviewersByProjectId(this.projectId).subscribe(data => {
      this.reviewerOptions = data["data"];
      this.reviewerOptions = this.reviewerOptions.filter(option => option.name !== this.codeReviewCreatedBy);
      this.codeReviewersForm.controls.reviewers.setValue(this.reviewerOptions.filter(option => 
        this.assignedReviewers.some(assigned => (assigned.user_id["$oid"] ? assigned.user_id["$oid"] : assigned.user_id) === (option.user_id["$oid"] ? option.user_id["$oid"] : option.user_id))
      ));
      this._sharedService.loaderHide.emit(false);
    }, error => {
      this._sharedService.loaderHide.emit(false);
    });
  }

  updateAssignedReviewers(): void {
    if (!this.codeReviewersForm.valid) {
      return;
    }
    this._sharedService.loaderHide.emit(true);

    let codeReviewers: { [key: string]: CodeReviewerModel } = {};
    if (this.codeReviewersForm.controls.reviewers.value.length > 0) {
      this.codeReviewersForm.controls.reviewers.value.forEach((reviewer) => {
        const assignedReviewer = this.assignedReviewers.find(
          (assigned) => assigned.user_id === reviewer.user_id
        );
        codeReviewers[reviewer.user_id.$oid ? reviewer.user_id.$oid :reviewer.user_id] = assignedReviewer ? assignedReviewer : reviewer;
      });
    }

    this._codeReviewService.updateCodeReviewersByCodeReviewId(codeReviewers, this.reviewId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in Updating Reviewers');
      } else {
        this.assignedReviewers = Object.values(codeReviewers);
        this.editReviewers = false;
        this.triggerParentCodeReviewModelUpdate();
      }
      this._sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Updating Reviewers');
      this._sharedService.loaderHide.emit(false);
    });
  }

  closeEditReviewers() {
    this.editReviewers = false;
  }

  initializecommentsModification() {
    // Fill commentsModification with an object for each comment
    this.commentsModification = this.codeReviewComments.map((codeReviewComment) => ({
      replyText: '',
      isEditing: false,
      editText: '',
      isReplying: false,
      replies: codeReviewComment.replies.map(() => ({
        replyText: '',
        isEditing: false,
        editText: '',
        isReplying: false
      }))
    }));
  }

  onReplyEdit(index: number, replyIndex: number) {
    this.commentsModification[index].replies[replyIndex].isEditing = true;
    this.commentsModification[index].replies[replyIndex].editText = this.getReply(this.codeReviewComments[index].replies[replyIndex]).body;
  }

  onReplyEditCancel(index: number, replyIndex: number) {
    this.commentsModification[index].replies[replyIndex].isEditing = false;
    this.commentsModification[index].replies[replyIndex].editText = '';
  }

  onCommentReplyDelete(index: number, replyIndex: number) {
    this._sharedService.loaderHide.emit(true);
    let commentReplyId = this.codeReviewComments[index].replies[replyIndex]["$oid"] ? this.codeReviewComments[index].replies[replyIndex]["$oid"] : this.codeReviewComments[index].replies[replyIndex];
    let parentCommentId = this.codeReviewComments[index]._id["$oid"] ? this.codeReviewComments[index]._id["$oid"] : this.codeReviewComments[index]._id;
    this._codeReviewService.deleteCommentReplyByCommentReplyId(commentReplyId, parentCommentId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in Deleting Comment');
      } else {
        this.isUpdatingDeleted = true;        
        let replyCommentModelIndex: number = this.getReplyIndexInCodeReviewComments(this.codeReviewComments[index].replies[replyIndex]);
        this.codeReviewComments[index].replies.splice(replyIndex, 1);
        this.commentsModification[index].replies.splice(replyIndex, 1);
        this.commentsModification.splice(replyCommentModelIndex, 1);
        this.codeReviewComments.splice(replyCommentModelIndex, 1);
        this.isUpdatingDeleted = false; 
        this.notifyService.notify('warning', 'Deleted', "Comment Deleted Sucessfully");
      }
      this._sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Deleting Comment');
      this._sharedService.loaderHide.emit(false);
    });
  }

  onReplyEditSubmit(index: number, replyIndex: number) {
    if(this.commentsModification[index].replies[replyIndex].editText != '') {
      this._sharedService.loaderHide.emit(true);
      let commentId = this.codeReviewComments[index].replies[replyIndex]["$oid"] ? this.codeReviewComments[index].replies[replyIndex]["$oid"] : this.codeReviewComments[index].replies[replyIndex];
      this._codeReviewService.updateCommentByCommentId(this.commentsModification[index].replies[replyIndex].editText, commentId).subscribe(data => {      
        if(data["operationStatus"] == "ERROR") {
          this.notifyService.notify('error', 'Failed', 'Error in Updating Comment');
        } else {
          let replyCommentModelIndex: number = this.getReplyIndexInCodeReviewComments(this.codeReviewComments[index].replies[replyIndex]);
          this.codeReviewComments[replyCommentModelIndex].body = this.commentsModification[index].replies[replyIndex].editText;
          this.codeReviewComments[replyCommentModelIndex].comment_history.push(data["data"]);
          this.commentsModification[index].replies[replyIndex].editText = '';
          this.commentsModification[index].replies[replyIndex].isEditing = false;
        }
        this._sharedService.loaderHide.emit(false);
      }, error => {
        this.notifyService.notify('error', 'Failed', 'Error in Updating Comment');
        this._sharedService.loaderHide.emit(false);
      });
    }
  }

  onEdit(index: number) {
    this.commentsModification[index].isEditing = true;
    this.commentsModification[index].editText = this.codeReviewComments[index].body;
  }

  onEditCancel(index: number) {
    this.commentsModification[index].isEditing = false;
    this.commentsModification[index].editText = '';
  }

  onCommentDelete(index: number) {
    this._sharedService.loaderHide.emit(true);
    let deleteCommentId = this.codeReviewComments[index]._id["$oid"] ? this.codeReviewComments[index]._id["$oid"] : this.codeReviewComments[index]._id;
    let deleteCodeReviewId = this.codeReviewComments[index].code_review_id["$oid"] ? this.codeReviewComments[index].code_review_id["$oid"] : this.codeReviewComments[index].code_review_id;
      this._codeReviewService.deleteCommentByCommentId(deleteCommentId, deleteCodeReviewId).subscribe(data => {      
        if(data["operationStatus"] == "ERROR") {
          this.notifyService.notify('error', 'Failed', 'Error in Deleting Comment');
        } else {
          this.isUpdatingDeleted = true; 
          this.codeReviewComments.splice(index, 1);
          this.commentsModification.splice(index, 1);
          this.isUpdatingDeleted = false; 
          this.notifyService.notify('warning', 'Deleted', "Comment Deleted Sucessfully");
        }
        this._sharedService.loaderHide.emit(false);
      }, error => {
        this.notifyService.notify('error', 'Failed', 'Error in Deleting Comment');
        this._sharedService.loaderHide.emit(false);
    });
  }

  onEditSubmit(index: number) {
    if(this.commentsModification[index].editText != '') {
      this._sharedService.loaderHide.emit(true);
      let commentId = this.codeReviewComments[index]._id["$oid"] ? this.codeReviewComments[index]._id["$oid"] : this.codeReviewComments[index]._id;
      this._codeReviewService.updateCommentByCommentId(this.commentsModification[index].editText, commentId).subscribe(data => {      
        if(data["operationStatus"] == "ERROR") {
          this.notifyService.notify('error', 'Failed', 'Error in Updating Comment');
        } else {
          this.codeReviewComments[index].body = this.commentsModification[index].editText;
          this.codeReviewComments[index].comment_history.push(data["data"]);
          this.commentsModification[index].editText = '';
          this.commentsModification[index].isEditing = false;
        }
        this._sharedService.loaderHide.emit(false);
      }, error => {
        this.notifyService.notify('error', 'Failed', 'Error in Updating Comment');
        this._sharedService.loaderHide.emit(false);
      });
    }
  }

  updateConversationResolution(index: number,resolution: boolean) {
    this._sharedService.loaderHide.emit(true);
    let commentId = this.codeReviewComments[index]._id["$oid"] ? this.codeReviewComments[index]._id["$oid"] : this.codeReviewComments[index]._id;
    this._codeReviewService.updateConversationResolutionByCommentId(resolution, commentId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in ' + resolution?" ": "Un" + 'Resolving Comment');
      } else {
        this.codeReviewComments[index]= data["data"];
      }
      this._sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in ' + resolution?" ": "Un" + 'Resolving Comment');
      this._sharedService.loaderHide.emit(false);
    });
  }

  onReply(index: number) {
    this.commentsModification[index].isReplying = true;
  }

  onReplyCancel(index: number) {
    this.commentsModification[index].isReplying = false;
    this.commentsModification[index].replyText = '';
  }

  onReplySubmit(index: number) {
    if(this.commentsModification[index].replyText != '') {
      this._sharedService.loaderHide.emit(true);
      let commentId = this.codeReviewComments[index]._id["$oid"] ? this.codeReviewComments[index]._id["$oid"] : this.codeReviewComments[index]._id;
      this._codeReviewService.addReviewCommentReplyByCommentId(this.commentsModification[index].replyText, commentId).subscribe(data => {
        if(data["operationStatus"] == "ERROR") {
          this.notifyService.notify('error', 'Failed', 'Error in Adding reply Comment');
        } else {
          this.commentsModification[index].replyText = '';
          this.commentsModification[index].isReplying = false;
          this.commentsModification[index].replies.push({
            replyText: '',
            isEditing: false,
            editText: '',
            isReplying: false
          });
          this.codeReviewComments.push(data["data"]);
          this.codeReviewComments[index].replies.push(data["data"]._id);
        }
        this._sharedService.loaderHide.emit(false);
      }, error => {
        this.notifyService.notify('error', 'Failed', 'Error in Adding Reply Comment');
        this._sharedService.loaderHide.emit(false);
      });
    }
  }

  getReply(replyId: string): CodeReviewCommentModel {
    return this.codeReviewComments.find(comment => replyId["$oid"] ? (comment._id["$oid"] ? comment._id["$oid"] === replyId["$oid"] : comment._id === replyId["$oid"]) : (comment._id["$oid"] ? comment._id["$oid"] === replyId : comment._id === replyId));
  }

  getReplyIndexInCodeReviewComments(replyId: string): number {
    return this.codeReviewComments.findIndex(comment => replyId["$oid"] ? (comment._id["$oid"] ? comment._id["$oid"] === replyId["$oid"] : comment._id === replyId["$oid"]) : (comment._id["$oid"] ? comment._id["$oid"] === replyId : comment._id === replyId));
  }

  requestReReview(reviewer: CodeReviewerModel) {
    this.isReviewerLoading = true;
    let userId = reviewer.user_id["$oid"] ? reviewer.user_id["$oid"] : reviewer.user_id;
    this._codeReviewService.requestReReviewByCommentId(userId, this.reviewId).subscribe(data => {
      if (data["data"] == null || data["operationStatus"] == "ERROR") {
      } else {
        let reviewerIndex = this.getAssignedReviewerIndexByUserId(reviewer.user_id);
        this.assignedReviewers[reviewerIndex].approved = false;
        this.assignedReviewers[reviewerIndex].requested_for_change = false;
        this.triggerParentCodeReviewModelUpdate();
      }
      this.isReviewerLoading = false;
    }, error => {
      this.isReviewerLoading = false;
    });
  }

  getAssignedReviewerIndexByUserId(userId: string) {
    return this.assignedReviewers.findIndex(reviewer => reviewer.user_id == userId);
  }

  openCodeReview() {
    this._sharedService.loaderHide.emit(true);
    this._codeReviewService.reOpenCodeReviewByCodeReviewId(this.reviewId).subscribe(data => {
      if(data["operationStatus"] == "ERROR") {
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('error', 'Failed', 'Error in Reopening Code review');
      } else {
        this.codeReviewState = "OPENED";
        this.notifyService.notify('success', 'Success', 'Code Review Reopened');
        this._sharedService.loaderHide.emit(false);
        this.router.navigate([`/code-link-review/${this.reviewId}`]);
        this.triggerParentCodeReviewModelUpdate();
      }
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Reopening Code review');
      this._sharedService.loaderHide.emit(false);
    });
  }

  closeCodeReview() {
    this._sharedService.loaderHide.emit(true);
    this._codeReviewService.closeCodeReviewByCodeReviewId(this.reviewId).subscribe(data => {
      if(data["operationStatus"] == "ERROR") {
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('error', 'Failed', 'Error in Closing Code review');
      } else {
        this.codeReviewState = "CLOSED";
        this.notifyService.notify('success', 'Success', 'Code Review Closed');
        this._sharedService.loaderHide.emit(false);
        this.router.navigate([`/code-link-review`]);
      }
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Closing Code review');
      this._sharedService.loaderHide.emit(false);
    });
  }

  triggerParentCodeReviewModelUpdate() {
    this._codeReviewService.triggerCodeReviewModelUpdate();
  }

  getFirstData(data: any): { key: string; value: any } | null {
    const index = this.technicalDetailsModelList.findIndex(technicalDetailsModel => technicalDetailsModel._id == data);
    if (index != -1) {
      const technicalDetailsData = this.technicalDetailsModelList[index]["data"];
      if (this.technicalDetailsModelList[index]['source']=='github') {
        return { key: "file name", value: technicalDetailsData["file name"] };
      }
      const keys = Object.keys(technicalDetailsData);
      if (keys.length > 0) {
        return { key: keys[0], value: technicalDetailsData[keys[0]] }; // Return an object with the first key and its value
      }
      return null; // Return null if no keys exist
    }
    return null;
  }
}
